import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SectionHead, Reveal } from "@/components/Reveal";
import { DEMOS } from "@/data/content";

export default function DemoCentre() {
    return (
        <section id="demos" className="relative border-t border-white/10 bg-void py-28 md:py-36" data-testid="demos-section">
            <div className="mx-auto max-w-[1400px] px-5 md:px-10">
                <SectionHead
                    number="04"
                    label="The demo centre"
                    title="Don't read about it. Walk through it."
                    copy="Complete interactive businesses built by HIGHTS — websites and applications you can actually use, each wired into the same automated customer journey. The library grows with every build."
                />
                <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-12">
                    {DEMOS.map((demo, i) => (
                        <Reveal key={demo.id} delay={(i % 2) * 0.1} className={i % 2 === 0 ? "md:col-span-7" : "md:col-span-5"}>
                            <Link
                                to={demo.href}
                                data-testid={`demo-card-${demo.id}`}
                                className="group block border border-white/12 bg-surface transition-colors duration-300 hover:border-white/35"
                            >
                                <div className="relative aspect-[16/9] overflow-hidden">
                                    <img
                                        src={demo.img}
                                        alt={demo.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover opacity-80 transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
                                    <div className="absolute left-5 top-5 flex items-center gap-2 border border-white/20 bg-black/60 px-3 py-1.5 backdrop-blur-md">
                                        <demo.icon size={14} className="text-white/80" />
                                        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/80">{demo.type}</span>
                                    </div>
                                </div>
                                <div className="flex items-start justify-between gap-4 p-7">
                                    <div>
                                        <h3 className="font-display text-2xl font-black tracking-tight text-white">{demo.title}</h3>
                                        <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-white/50">{demo.desc}</p>
                                    </div>
                                    <span className="mt-1 flex h-11 w-11 shrink-0 items-center justify-center border border-white/20 text-white transition-all duration-300 group-hover:bg-white group-hover:text-black">
                                        <ArrowUpRight size={18} />
                                    </span>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
